'use strict';

var base = require('base/product/base');
var focusHelper = require('base/components/focus');
var scrollAnimate = require('../components/scrollAnimate');

var EDIT_PRODUCT_MODAL = '#editProductModal';
var MINICART_QUANTITY = '.minicart-quantity';
var MINICART_LINK = '.minicart-link';
var CART_BEFORE_UPDATE = 'cart:beforeUpdate';
var CART_UPDATE = 'cart:update';
var PRE_SELECT_QTY = 'pre-select-qty';
var CART_AND_IPAY = '.cart-and-ipay';
var PRODUCT_AVAILABILITY = '.product-availability';
var GLOBAL_AVAILABILITY = '.global-availability';
var AVAILABILITY_MSG = '.availability-msg';
var UPDATE_CART_URL = '.update-cart-url';
var PRODUCT_ATTRS = '.product-attrs';
var DATA_READY_TO_ORDER = 'ready-to-order';
var DATA_AVAILABLE = 'available';
var QUANTITY_UUID_SELECTOR = '.quantity[data-uuid="';
var REMOVE_PRODUCT = '.remove-product';
var DIV_ROW = '<div class="row"> ';
var DIV_COL_12 = '<div class="col-12"> ';
var UPDATE_CART_PRODUCT_GLOBAL = '.update-cart-product-global';
var CART_SELECTOR = '.cart';
var UUID_ITEM_PREFIX = '.uuid-';
var MODAL_BODY = '.modal-body';
var ARIA_HIDDEN_TIMES_SPAN = '<span aria-hidden="true">&times;</span>';

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]); // NOSONAR
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' + // NOSONAR
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                ARIA_HIDDEN_TIMES_SPAN +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $(CART_SELECTOR).empty().append(DIV_ROW + // NOSONAR
                DIV_COL_12 +
                data.basket.resources.emptyCartMsg +
                '</div> ' +
                '</div>'
            );
            $(MINICART_QUANTITY).empty().append(data.numItems);
            $(MINICART_LINK).attr({
                'aria-label': data.resources.minicartCountOfItems, // NOSONAR
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('#cartSummaryContainer').empty().append(data.cartCheckoutSummary); // summary update
    //$('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $(MINICART_QUANTITY).empty().append(data.numItems);
    $(MINICART_LINK).attr({
        'aria-label': data.resources.minicartCountOfItems, // NOSONAR
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $(UUID_ITEM_PREFIX + item.UUID + ' .unit-price').empty().append(item.renderedPrice); // NOSONAR
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice); // NOSONAR
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' + // NOSONAR
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        ARIA_HIDDEN_TIMES_SPAN +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">' // NOSONAR
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>'; // NOSONAR
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">' // NOSONAR
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($(EDIT_PRODUCT_MODAL).length !== 0) {
        $(EDIT_PRODUCT_MODAL).remove();
    }
    var htmlString = '<!-- Modal -->' // NOSONAR
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        ' + ARIA_HIDDEN_TIMES_SPAN
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $(MODAL_BODY).spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $(EDIT_PRODUCT_MODAL + ' ' + MODAL_BODY).empty(); // NOSONAR
            $(EDIT_PRODUCT_MODAL + ' ' + MODAL_BODY).html(parsedHtml.body); // NOSONAR
            $(EDIT_PRODUCT_MODAL + ' .modal-footer').html(parsedHtml.footer);
            $(EDIT_PRODUCT_MODAL + ' .modal-header .close .sr-only').text(data.closeButtonText);
            $(EDIT_PRODUCT_MODAL + ' .enter-message').text(data.enterDialogMessage);
            $(EDIT_PRODUCT_MODAL).modal({backdrop: 'static', keyboard: false});
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */

function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

function enableDisableQtyBtn(quantity, prodctAttr) {
    if (parseInt(quantity) >= 999) {
        $(prodctAttr).find('.plus.icon-update-qty').attr('disabled', 'disabled');
    } else {
        $(prodctAttr).find('.plus.icon-update-qty').removeAttr('disabled');
    }
}

function pushCartAdobeDataLayerVal(data) {
    if (window.adobeDataLayer && data.dumbleData && data.dumbleData.cart) {
        window.adobeDataLayer.push({
            "event": "cart-update",
            "cart": data.dumbleData.cart
        });
    }
}

function cartUpdate(qtyInput, quantity, preSelectQty) {
    var productID = $(qtyInput).data('pid');
    var url = $(qtyInput).data('action');
    var uuid = $(qtyInput).data('uuid');

    var urlParams = {
        pid: productID,
        quantity: quantity,
        uuid: uuid
    };
    url = appendToUrl(url, urlParams);

    $(qtyInput).parents('.card-body').spinner().start();

    $('body').trigger(CART_BEFORE_UPDATE);

    $.ajax({
        url: url,
        type: 'get',
        context: this,
        dataType: 'json',
        success: function (data) {
            $(QUANTITY_UUID_SELECTOR + uuid + '"]').val(quantity); // NOSONAR
            updateCartTotals(data);
            updateApproachingDiscounts(data.approachingDiscounts);
            updateAvailability(data, uuid);
            validateBasket(data);

            $(qtyInput).data(PRE_SELECT_QTY, quantity);

            pushCartAdobeDataLayerVal(data);
            $('body').trigger(CART_UPDATE, data);

            $.spinner().stop();
            if ($(qtyInput).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                location.reload();
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                $(qtyInput).val(parseInt(preSelectQty, 10));
                $.spinner().stop();
            }
        }
    });
}

function removeProductLineItem(url, uuid) {
    $.spinner().start();
    $('body').trigger(CART_BEFORE_UPDATE);

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            if (data.basket.items.length === 0) {
                if (data.hasWishlistItems) {
                    $(CART_SELECTOR).empty().append(DIV_ROW + // NOSONAR
                        DIV_COL_12 +
                        data.basket.resources.emptyCartMsg +
                        '<div class="align-items-left align-items-sm-start"> ' +
                        '<a class="wishlist-show-link float-left" href="' + data.basket.actionUrls.wishlistURL +
                        '" data-element-linkname="Cart | ' + data.basket.resources.viewWishlistMsg + '"> ' +
                        '<i class="fa-solid fa-rectangle-list"></i> ' +
                        data.basket.resources.viewWishlistMsg +
                        '</a>' +
                        '</div> ' +
                        '</div> ' +
                        '</div>'
                    );
                } else {
                    $(CART_SELECTOR).empty().append(DIV_ROW + // NOSONAR
                        DIV_COL_12 +
                        data.basket.resources.emptyCartMsg +
                        '</div> ' +
                        '</div>'
                    );
                }
                $(MINICART_QUANTITY).empty().append(data.basket.numItems);
                $(MINICART_LINK).attr({
                    'aria-label': data.basket.resources.minicartCountOfItems, // NOSONAR
                    title: data.basket.resources.minicartCountOfItems
                });
                $('body').removeClass('modal-open');
                $('html').removeClass('veiled');
            } else {
                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $(UUID_ITEM_PREFIX + data.toBeDeletedUUIDs[i]).remove();
                    }
                }
                $(UUID_ITEM_PREFIX + uuid).remove();
                if (!data.basket.hasBonusProduct) {
                    $('.bonus-product').remove();
                }
                updateCartTotals(data.basket);
                updateApproachingDiscounts(data.basket.approachingDiscounts);
                $('body').trigger('setShippingMethodSelection', data.basket);
                validateBasket(data.basket);
            }

            pushCartAdobeDataLayerVal(data);
            $('body').trigger(CART_UPDATE, data);

            $.spinner().stop();
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                $.spinner().stop();
            }
        }
    });
}

/**
 * move items from Cart to wishlist
 * returns json object with success or error message
 */
function moveToWishlist(curEle) {
    var url = curEle.data('addtowishlist');
    var pid = curEle.data('pid');
    if (!url || !pid) {
        return;
    }

    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid
        },
        success: function (data) {
            $.spinner().stop();
            var url = curEle.data('removelineitem');
            var uuid = curEle.data('uuid');
            var urlParams = {
                pid: pid,
                uuid: uuid
            };

            url = appendToUrl(url, urlParams);
            removeProductLineItem(url, uuid);
        },
        error: function (err) {
            if (!err.responseJSON.loggedin && err.responseJSON.loginUrl) {
                $('body').trigger('signinModal:open', err.responseJSON.loginUrl);
                if(curEle.closest('.product-quickview').length) {
                    $('#quickViewModal .close').trigger('click');
                }
            }
            $.spinner().stop();
        }
    });
}

module.exports = function () {
    $('body').on('click', '.cart-delete-cancel-btn', function(e) {
        e.preventDefault();
        var uuid = $(this).siblings('button').data('uuid'),
            qtyInput = $(QUANTITY_UUID_SELECTOR + uuid + '"]'), // NOSONAR
            qtyValue = $(qtyInput).val() ? parseInt($(qtyInput).val()) : 0;
        if (!qtyValue) {
            var quantity = $(qtyInput).data(PRE_SELECT_QTY);
            $(QUANTITY_UUID_SELECTOR + uuid + '"]').val(quantity); // NOSONAR
        }
    });

    $('body').on('click', REMOVE_PRODUCT, function () {
        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        removeProductLineItem(url, uuid);
    });

    $('body').on("keyup", '.quantity-form .quantity',  function(e) {
		if ( e.which === 13 && this.value !== $(this).data(PRE_SELECT_QTY) ) {
			$(this).blur();
		}
	});

    $('body').on("focusout", '.quantity-form .quantity',  function() {
        var qtyInput = $(this),
            quantity = $(qtyInput).val(),
            prodctAttr = $(qtyInput).parents(PRODUCT_ATTRS),
            preSelectQty = $(qtyInput).data(PRE_SELECT_QTY);

        enableDisableQtyBtn(quantity, prodctAttr);

		if (quantity !== preSelectQty) {
			if (parseInt($(qtyInput).val()) === 0) {
				$(qtyInput).parents(PRODUCT_ATTRS).find(REMOVE_PRODUCT).trigger('click');
			} else {
                cartUpdate(qtyInput, quantity, preSelectQty);
			}
		}
	});

    $('body').on("click", '.quantity-form .icon-update-qty', function(e) {
		e.preventDefault();
        var isMinus = $(this).hasClass('minus'),
            qtyInput = $(this).parent().find('input'),
            preSelectQty = $(qtyInput).data(PRE_SELECT_QTY) ? parseInt($(qtyInput).data(PRE_SELECT_QTY)) : 1,
            updatedQty = isMinus ? preSelectQty-1 : preSelectQty+1,
            prodctAttr = $(this).parents(PRODUCT_ATTRS);

        enableDisableQtyBtn(updatedQty, prodctAttr);

        if (updatedQty === 0) {
            $(this).parents(PRODUCT_ATTRS).find(REMOVE_PRODUCT).trigger('click');
        } else {
            cartUpdate(qtyInput, updatedQty, preSelectQty);
        }
	});

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', EDIT_PRODUCT_MODAL, function () {
        $(EDIT_PRODUCT_MODAL).siblings().attr('aria-hidden', 'true');
        $(EDIT_PRODUCT_MODAL + ' .close').focus();
    });

    $('body').on('hidden.bs.modal', EDIT_PRODUCT_MODAL, function () {
        $(EDIT_PRODUCT_MODAL).siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', EDIT_PRODUCT_MODAL, function (e) {
        var focusParams = {
            event: e,
            containerSelector: EDIT_PRODUCT_MODAL,
            firstElementSelector: '.close',
            lastElementSelector: UPDATE_CART_PRODUCT_GLOBAL,
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $(UPDATE_CART_PRODUCT_GLOBAL, dialog).attr('disabled',
            !$(GLOBAL_AVAILABILITY, dialog).data(DATA_READY_TO_ORDER)
            || !$(GLOBAL_AVAILABILITY, dialog).data(DATA_AVAILABLE)
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $(PRODUCT_AVAILABILITY, response.$productContainer)
            .data(DATA_READY_TO_ORDER, response.product.readyToOrder)
            .data(DATA_AVAILABLE,response.product.available)
            .find(AVAILABILITY_MSG)
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($(PRODUCT_AVAILABILITY, dialog).length) {
            // bundle all products
            var allAvailable = $(PRODUCT_AVAILABILITY, dialog).toArray()
                .every(function (item) { return $(item).data(DATA_AVAILABLE); });

            var allReady = $(PRODUCT_AVAILABILITY, dialog).toArray()
                .every(function (item) { return $(item).data(DATA_READY_TO_ORDER); });

            $(GLOBAL_AVAILABILITY, dialog)
                .data(DATA_READY_TO_ORDER, allReady)
                .data(DATA_AVAILABLE,allAvailable);

            $(GLOBAL_AVAILABILITY + ' ' + AVAILABILITY_MSG, dialog).empty() // NOSONAR
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $(GLOBAL_AVAILABILITY, dialog)
                .data(DATA_READY_TO_ORDER, response.product.readyToOrder)
                .data(DATA_AVAILABLE,response.product.available)
                .find(AVAILABILITY_MSG)
                .empty()
                .html(response.message);
        }
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', UPDATE_CART_PRODUCT_GLOBAL, function (e) {
        e.preventDefault();

        var $cartAndIpay = $(this).closest(CART_AND_IPAY);
        var updateProductUrl = $cartAndIpay.find(UPDATE_CART_URL).val();
        var selectedQuantity = $cartAndIpay.find(UPDATE_CART_URL).data('selected-quantity');
        var selectedOptionValueId = $cartAndIpay.find(UPDATE_CART_URL).data('selected-option');
        var uuid = $cartAndIpay.find(UPDATE_CART_URL).data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger(CART_BEFORE_UPDATE);

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $(EDIT_PRODUCT_MODAL).modal('hide');

                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $(UUID_ITEM_PREFIX + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger(CART_UPDATE, data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    // Scroll to summary detail
    $('body').on('click', '#btnSummaryDetail', function() {
        scrollAnimate($('#checkoutbar-fixed'));
    });

    $('body').on('click', '.move-to-wishlist', function (e) {
        e.preventDefault();
        moveToWishlist($(this));
    });
};
